import React, { Component } from 'react';
import { Button, TextField } from '@material-ui/core';
import styled from 'styled-components';

import './SignInPage.scss';
import { inject } from 'mobx-react';

const Heading = styled.h1`
  margin-top: 0;
`;

const FormContainer = styled.div`
  max-width: 480px;
  width: 100%;
  background-color: #edf4ff;
  padding: 30px;
  border-radius: 5px;
`;

const FormField = styled(TextField)`
  width: 100%;
`;

const ErrorMessage = styled.div`
  color: white;
  background-color: #ff4d4d;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  text-align: center;
`;

@inject('userStore', 'routerStore', 'notesStore')
class SignInPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: null, // Store error state
    };
  }

  submit = async () => {
    this.setState({ error: null }); // Reset error before submission
    const { email, password } = this.state;

    try {
      await this.props.userStore.signin(email, password);
      const paymentPlan = await this.props.notesStore.getPaymentPlan();
      if (!paymentPlan.data) {
        window.location.hash = '/payment';
      } else {
        window.location.hash = '/notes';
      }
    } catch (error) {
      console.error(error);
      // Set a user-friendly error message
      this.setState({
        error: 'Either the email or password is incorrect. Please try again or email info@notesfrombeyond.com for assistance.',
      });
    }
  };

  goToSignUp = () => {
    window.location.hash = '/signup';
  };

  render() {
    const { error } = this.state;

    return (
      <div className="fullscreen-wrapper">
        <FormContainer>
          <Heading>Hello!</Heading>
          <p>Fill in your email and password to sign in.</p>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <div>
            <FormField
              id="email"
              label="Email"
              margin="dense"
              variant="outlined"
              onChange={(e) => this.setState({ email: e.target.value })}
            />
          </div>
          <div>
            <FormField
              id="password"
              label="Password"
              margin="dense"
              variant="outlined"
              type="password"
              onChange={(e) => this.setState({ password: e.target.value })}
            />
          </div>
          <hr />
          <div>
            <Button
              style={{ marginBottom: '10px' }}
              fullWidth
              variant="contained"
              color="primary"
              onClick={this.submit}
            >
              SIGN IN
            </Button>

            <Button fullWidth onClick={this.goToSignUp}>
              Don't have an account? Sign up now!
            </Button>
          </div>
        </FormContainer>
      </div>
    );
  }
}

export default SignInPage;
